import { GameLevel } from './game-config';
import { Trophy } from './trophy';
import { BasicProgress, GenericProgressStatus, ScoreFindStrategy } from '../models';

export const MAXIMUM_SCORE = 100;

export class ScoreSummary implements BasicProgress {
  badge?: Trophy;
  score?: number;
  status: GenericProgressStatus;
  time?: number;
  difficulty?: GameLevel;
  params?: any;
  strategy?: ScoreFindStrategy;
  percentage?: number;
  nbTimeDone?: number;

  constructor(summary?: ScoreSummary) {
    this.status = summary?.status || GenericProgressStatus.NOT_STARTED;
    this.badge = summary?.badge;
    this.score = summary?.score;
    this.time = summary?.time;
    this.difficulty = summary?.difficulty;
    this.params = summary?.params;
    this.strategy = summary?.strategy;
    this.percentage = summary?.percentage;
    this.nbTimeDone = summary?.nbTimeDone;
  }
}
